import React, { FC, useCallback } from 'react';

import { useFormContext } from 'react-hook-form';

import Input from 'components/Input/Input';

interface IAvailabilityInputProps {
  id: string;
  placeholder?: string;
  className?: string;
}

const AvailabilityInput: FC<IAvailabilityInputProps> = ({
  id,
  placeholder = 'Set availability',
  className
}): React.ReactElement => {
  const form = useFormContext();
  const playerAvailability = form.watch('playerAvailability');
  const setAsFree = form.watch('setAsFree');
  const error = form.formState.errors.playerAvailability;
  const hasError = !!error;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      const raw = e.target.value;
      const value = raw === '' ? undefined : Number(raw);
      form.setValue('playerAvailability', value, {
        shouldDirty: true,
        shouldValidate: true
      });
    },
    [form]
  );

  const handleBlur = useCallback((): void => {
    form.trigger('playerAvailability');
  }, [form]);

  return (
    <Input
      label="Availability"
      id={id}
      name="playerAvailability"
      type="number"
      className={className}
      placeholder={placeholder}
      min={0}
      value={playerAvailability || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      isRequired={setAsFree}
      state={hasError ? 'error' : 'default'}
      description={hasError ? String(error.message || '') : ''}
    />
  );
};

export { AvailabilityInput };
